import templateUrl from './shiftTemplateSelectionGroupComponent.html';

export default {
  templateUrl,
  controllerAs: 'ctrl',
  bindings: {
    templates: '<',
    selectTemplate: '&',
    scrollParent: '<',
  },
};
